import type { Survey } from "@/features/survey/types";
import { Link } from "react-router";

interface ExploreMarketsCardProps {
  surveys: Survey[];
}

/**
 * Glass-panel market list overlaid on the group cover's hero image;
 * selecting a market navigates to that survey's Market Map.
 */
const ExploreMarketsCard = ({ surveys }: ExploreMarketsCardProps) => {
  if (surveys.length === 0) return null;

  return (
    <nav
      aria-label="Explore markets"
      className="absolute top-6 right-6 z-10 hidden w-[min(260px,50%)] flex-col bg-[rgba(48,48,46,0.42)] shadow-[0_20px_50px_rgba(0,0,0,.25)] backdrop-blur-[22px] backdrop-saturate-[1.1] lg:flex"
    >
      <h2
        className="fancy m-0"
        style={{
          fontSize: "clamp(18px, 1.6vw, 24px)",
          lineHeight: 1.15,
          fontWeight: 400,
          padding: "24px 24px 14px",
          color: "#fff",
        }}
      >
        Explore Markets
      </h2>
      <div className="mx-6 h-px bg-white" />
      <ul className="m-0 list-none" style={{ padding: "14px 24px 24px" }}>
        {surveys.map((survey) => (
          <li key={survey.id}>
            <Link
              to={`/interactive/${survey.id}/marketmap`}
              className="group flex items-center gap-2 py-1.5 text-white no-underline"
              style={{ fontSize: "13px", fontWeight: 500 }}
            >
              <span className="h-0.5 w-5 flex-none bg-accent transition-[width] duration-200 group-hover:w-8" />
              <span className="group-hover:text-accent">{survey.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ExploreMarketsCard;
